/**
 * Frontend access-control helper — UX ONLY.
 *
 * The frontend has no authority: this helper just decides whether to
 * render the customer-facing link. Any actual data access must be (and
 * is) enforced by the backend on every route.
 *
 * A user can access customer data if the backend has flagged them as:
 *   • customer    — sees only their own company (server-scoped)
 *   • is_admin, is_super_admin, is_main_company_staff — set by the
 *     server on /auth/login and /auth/me, computed from the shared
 *     ``backend/main_company.py`` registry + Admins list.
 *
 * There is deliberately NO hardcoded email-domain list on the client:
 *   1. It was security-theatre (browser JS is fully user-editable, so
 *      anyone could bypass it in seconds).
 *   2. It drifted from the backend's five other domain checks.
 *   3. It couldn't reflect super-admin runtime additions.
 * If the backend hasn't sent an elevation flag, the answer is "no" —
 * and the backend will 403 the API call regardless.
 */
export function canAccessCustomers(user) {
  if (!user) return false;
  if (user.role === "customer") return true;
  return !!(user.is_super_admin || user.is_admin || user.is_main_company_staff);
}
